var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.951 42.5226L16.2324 23.3241H38.3847L40.6662 42.5226H13.951ZM27.3086 13.4786C30.7045 13.4786 33.4696 16.2437 33.4696 19.6444H21.1476C21.1476 16.2437 23.9127 13.4786 27.3086 13.4786ZM41.6545 19.6444H37.1494C37.1494 14.2093 32.7442 9.79883 27.3086 9.79883C21.873 9.79883 17.4678 14.2093 17.4678 19.6444H12.9627L9.80859 46.2024H44.8086L41.6545 19.6444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/Purchase.4d247c11d99a634f3c70f519cd7fc095.svg";
export { ForwardRef as ReactComponent };